import axios from 'axios';

const options = { withCredentials: true };

axios.interceptors.response.use(
  response => response,
  error => {
    const url: string = error.config?.url ?? '';
    if (error.response?.status === 404 && url.includes('/api/auth/me')) {
      window.location.replace('/not-found');
      return new Promise(() => { });
    }
    if (error.response && error.response.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export const api = axios.create(options);
